import CartPanelExperienceTile from './CartPanelExperienceTile'
import CartPanelHotelTileDispatcher from './CartPanelHotelTileDispatcher'
import type { CartPanelAccommodationItem, CartPanelExperienceItem, CartPanelItem } from '../hooks/useCartPanelItems'

interface Props {
  item: CartPanelItem
  onToggleInclude: (item: CartPanelItem) => void
  onChangeRoom: (item: CartPanelItem) => void
  onSetDates: () => void
  onAdjustDays: (item: CartPanelItem) => void
  onChooseTickets: (item: CartPanelExperienceItem) => void
  onChooseDate: (item: CartPanelExperienceItem) => void
  onChooseTime: (item: CartPanelExperienceItem) => void
  onChooseDifferentTickets: (item: CartPanelExperienceItem) => void
  onDelete: (item: CartPanelItem) => void
  isStreaming: boolean
}

function isAccommodationItem(item: CartPanelItem): item is CartPanelAccommodationItem {
  return item.productType === 'accommodation'
}

function CartPanelItemDispatcher({
  item,
  onToggleInclude,
  onChangeRoom,
  onSetDates,
  onAdjustDays,
  onChooseTickets,
  onChooseDate,
  onChooseTime,
  onChooseDifferentTickets,
  onDelete,
  isStreaming,
}: Props) {
  if (isAccommodationItem(item)) {
    return (
      <CartPanelHotelTileDispatcher
        item={item}
        onToggleInclude={onToggleInclude}
        onChangeRoom={onChangeRoom}
        onSetDates={onSetDates}
        onAdjustDays={onAdjustDays}
        onDelete={onDelete}
        isStreaming={isStreaming}
      />
    )
  }

  return (
    <CartPanelExperienceTile
      item={item}
      onToggleInclude={onToggleInclude}
      onChooseTickets={onChooseTickets}
      onChooseDate={onChooseDate}
      onChooseTime={onChooseTime}
      onChooseDifferentTickets={onChooseDifferentTickets}
      onDelete={onDelete}
      isStreaming={isStreaming}
    />
  )
}

export default CartPanelItemDispatcher
